module.exports = __webpack_public_path__ + "img/list.f4bbfc14.svg";